const getWindow = () => (typeof window === 'object' ? window : undefined);

export default getWindow;
